module.exports = __webpack_public_path__ + "static/media/img-3.1d4e1cf2.jpg";